export const PROFILE_PAGES = [
  {
    id: 'overview',
    label: 'Company profile',
    navLabel: 'Company profile',
    path: '/msme-profile',
  },
  {
    id: 'disclosure',
    label: 'Boundaries',
    navLabel: 'Boundaries',
    path: '/msme-profile/boundaries',
  },
] as const;

/** Earlier disclosure URL. */
export const DISCLOSURE_PROFILE_PATH = '/msme-profile/disclosure';

/** Older profile routes now live on the company page. */
export const PROFILE_MERGED_PATHS = [
  '/msme-profile/identity',
  '/msme-profile/export',
  '/msme-profile/registration',
] as const;

export const PLANT_PROFILE_PATH = '/msme-profile/plant';

export type ProfilePageId = (typeof PROFILE_PAGES)[number]['id'];

export const profilePageFromPath = (pathname: string) =>
  PROFILE_PAGES.find((page) => page.path === pathname) ?? null;

export const OPERATIONS_PAGES = [
  {
    id: 'picture',
    label: 'Energy and meters',
    navLabel: 'Energy and meters',
    path: '/operations',
  },
  {
    id: 'units',
    label: 'Manufacturing units',
    navLabel: 'Manufacturing units',
    path: '/operations/units',
  },
  {
    id: 'scope1',
    label: 'Direct emissions',
    navLabel: 'Direct emissions',
    path: '/operations/scope-1',
  },
  {
    id: 'scope3',
    label: 'Value chain',
    navLabel: 'Value chain',
    path: '/operations/scope-3',
  },
] as const;

/** Operations review now lives on Boundaries. */
export const OPERATIONS_REVIEW_PATH = '/operations/review';

export type OperationsPageId = (typeof OPERATIONS_PAGES)[number]['id'];

export const operationsPageFromPath = (pathname: string) =>
  OPERATIONS_PAGES.find((page) => page.path === pathname) ?? null;

/** Planner section order: units, direct emissions, purchased electricity, value chain, review. */
const OPERATIONS_SECTION_PATHS = [
  '/operations/units',
  '/operations/scope-1',
  '/operations',
  '/operations/scope-3',
  '/msme-profile/boundaries',
] as const;

export const operationsPathForSection = (sectionIndex: number) =>
  OPERATIONS_SECTION_PATHS[sectionIndex] ?? '/operations/review';

/** My company order: company, operations pages, then the generated boundaries summary. */
export const myCompanyNavPages = () => [
  PROFILE_PAGES[0],
  ...OPERATIONS_PAGES,
  PROFILE_PAGES[1],
];
